/** 经营总览：回款预测 */

const emptyGrain = (kpiLabel, beyondLabel) => ({
	buckets: [],
	forecastableTotal: 0,
	beyondWindowTotal: 0,
	beyondWindowOrderCount: 0,
	kpiLabel,
	beyondLabel,
});

const emptyCollectionForecastBundle = () => ({
	asOf: null,
	overdueTotal: 0,
	overdueOrderCount: 0,
	quasiReceivableTotal: 0,
	quasiReceivableOrderCount: 0,
	unpaidArWithExpireTotal: 0,
	calendarDays: [],
	grains: {
		month: emptyGrain('未来 3 月预计到期', '3月外'),
		week: emptyGrain('未来 12 周预计到期', '12周外'),
		day: emptyGrain('未来 30 天预计到期', '30天外'),
	},
});

const mapForecastBuckets = (rows = []) =>
	(Array.isArray(rows) ? rows : []).map((row) => ({
		key: row?.key ?? '',
		label: row?.label ?? row?.key ?? '',
		amount: Number(row?.amount) || 0,
		orderCount: Number(row?.orderCount) || 0,
		isOverdue: Boolean(row?.isOverdue),
		orders: (Array.isArray(row?.orders) ? row.orders : []).map((order) => ({
			orderMongoId: order?.orderMongoId ?? '',
			orderId: order?.orderId ?? '',
			customerName: order?.customerName ?? '未知客户',
			amount: Number(order?.amount) || 0,
			titles: Array.isArray(order?.titles) ? order.titles : [],
			isOverdue: Boolean(order?.isOverdue),
			relatedNodes: (Array.isArray(order?.relatedNodes) ? order.relatedNodes : []).map((node) => ({
				date: node?.date ?? '',
				label: node?.label ?? node?.date ?? '',
				title: node?.title ?? '',
				amount: Number(node?.amount) || 0,
				isOverdue: Boolean(node?.isOverdue),
			})),
		})),
	}));

const mapForecastGrain = (grain, fallbackKpi, fallbackBeyond) => {
	if (!grain) {
		return emptyGrain(fallbackKpi, fallbackBeyond);
	}
	const buckets = mapForecastBuckets(grain.buckets?.length ? grain.buckets : grain.months);
	return {
		buckets,
		forecastableTotal: Number(grain.forecastableTotal) || buckets.reduce((sum, row) => sum + row.amount, 0),
		beyondWindowTotal: Number(grain.beyondWindowTotal) || 0,
		beyondWindowOrderCount: Number(grain.beyondWindowOrderCount) || 0,
		kpiLabel: grain.kpiLabel || fallbackKpi,
		beyondLabel: grain.beyondLabel || fallbackBeyond,
	};
};

/**
 * 回款预测卡：读服务端 overviewCollectionForecast（月/周/日三套桶）。
 * 无字段时返回空结构，禁止用账龄桶冒充。
 */

/**
 * 回款预测卡：读服务端 overviewCollectionForecast（月/周/日三套桶）。
 * 无字段时返回空结构，禁止用账龄桶冒充。
 */
export const buildCollectionForecastBundleFromStats = (stats) => {
	const server = stats?.overviewCollectionForecast;
	if (!server) {
		return emptyCollectionForecastBundle();
	}

	const hasGrains = Boolean(server.grains?.month || server.grains?.week || server.grains?.day);
	const monthGrain = hasGrains
		? mapForecastGrain(server.grains?.month, '未来 3 月预计到期', '3月外')
		: mapForecastGrain(
				{
					buckets: server.months,
					forecastableTotal: server.forecastableTotal,
					beyondWindowTotal: server.beyondWindowTotal,
					beyondWindowOrderCount: server.beyondWindowOrderCount,
					kpiLabel: '未来 3 月预计到期',
					beyondLabel: '3月外',
				},
				'未来 3 月预计到期',
				'3月外',
			);

	return {
		asOf: server.asOf ?? null,
		overdueTotal: Number(server.overdueTotal) || 0,
		overdueOrderCount: Number(server.overdueOrderCount) || 0,
		quasiReceivableTotal: Number(server.quasiReceivableTotal) || 0,
		quasiReceivableOrderCount: Number(server.quasiReceivableOrderCount) || 0,
		unpaidArWithExpireTotal: Number(server.unpaidArWithExpireTotal) || 0,
		calendarDays: mapForecastBuckets(server.calendarDays),
		grains: {
			month: monthGrain,
			week: mapForecastGrain(server.grains?.week, '未来 12 周预计到期', '12周外'),
			day: mapForecastGrain(server.grains?.day, '未来 30 天预计到期', '30天外'),
		},
	};
};

/**
 * 应收统计卡统一数据源（折线 / 双环 / 列表 / KPI 共用）：
 * 从 overdueData 账龄桶筛当前统计订单集，一次遍历产出账龄序列与销售/客户排行。
 * orderIdsList：服务端轻量 id 列表（无全量 orders 时用）。
 */
